import React from 'react';

import BaseFilter from './BaseFilter';
import { getQuestionnaries } from '../../../actions/asyncActions';
import withFilterForm from '../../hocs/withFilterForm';

export default withFilterForm(() =>
    <BaseFilter
        action={getQuestionnaries}
        searchFieldName='name'
        searchFieldPlaceholder='Поиск'
        span={12} />
);
